import { postToApi } from "venuescanner-js/services/api";
export default {
  get: async function (venueId) {
    return this.fetch(venueId);
  },

  removeAttachment: async function (venueId, attachmentPath) {
    const response = await postToApi("attachment/remove", {
      venue: venueId,
      attachmentPath,
    });
    return response;
  },
  fetch: async function (venueId) {
    const response = await postToApi("attachment/fetch", {
      venue: venueId,
    });
    return response;
  },
};
